import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Route, Routes } from "react-router-dom";
import "../src/style/app.css";
import Home from "./components/Home/Home";
import MessageFromEd from "./components/pages/about/MessageFromEd";
import MissionAndVision from "./components/pages/about/MissionAndVision";
import GeneralCouncil from "./components/pages/about/GeneralCouncil";
import ExecutiveCouncil from "./components/pages/about/ExecutiveCouncil";
import MotoAndValues from "./components/pages/about/MotoAndValues";
import NgoAb from "./components/pages/affiliation/NgoAb";
import SocialWelfare from "./components/pages/affiliation/SocialWelfare";
import JoinStock from "./components/pages/affiliation/JoinStock";
import TinAndBin from "./components/pages/affiliation/TinAndBin";
import SMT from "./components/pages/about/SMT";
import Constitution from "./components/pages/about/Constitution";
import AuditSystem from "./components/pages/about/AuditSystem";
import CompleteProject from "./components/pages/projects/CompleteProject";
import Notfound from "./components/shared/Notfound/Notfound";
import PastDonors from "./components/pages/Donors/PastDonors";
import CurrentDonor from "./components/pages/Donors/CurrentDonor";
import Organogram from "./components/pages/about/Organogram";
import Donation from "./components/pages/Donation";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import PhotoGallery from "./components/pages/resources/PhotoGallery";
import Contact from "./components/pages/Contact/Contact";
import FocusArea from "./components/pages/FocusArea/FocusArea";
import StrategicPlan from "./components/pages/FocusArea/StrategicPlan";
import ThematicIssue from "./components/pages/FocusArea/ThematicIssue";
import ProjectCompletionReport from "./components/pages/resources/ProjectCompletionReport";
import TradeLicense from "./components/pages/affiliation/TradeLicense";
import TenderNotice from "./components/pages/NoticeBoard/TenderNotice";
import Policy from "./components/pages/about/Policy";
import HappyNewYear from "./components/News/HappyNewYear";
import AllBlogs from "./components/pages/AllBlogs/AllBlogs";
import AnnualReport from "./components/pages/resources/AnnualReport";
import AuditReport from "./components/pages/resources/AuditReport";
import JobCircular from "./components/pages/NoticeBoard/JobCircular";
import AasCitizenCharter from "./components/pages/Helpdesk/AasCitizenCharter";
import EmergencyCall from "./components/pages/Helpdesk/EmergencyCall";
import Complain from "./components/pages/Helpdesk/Complain";
import SamAndDuns from "./components/pages/affiliation/SamAndDuns";
import OfficeNotice from "./components/pages/NoticeBoard/OfficeNotice";
import AdbCmsNumber from "./components/pages/affiliation/AdbCmsNumber";
import AdvisoryCouncil from "./components/pages/about/AdvisoryCouncil";
import JobCircularDYD from "./components/Home/JobCircular/JobCircularDYD";
import DevelopmentConcernBackground from "./components/pages/about/DevelopmentConcernBackground";
import DevelopmentConcernProfile from "./components/pages/about/DevelopmentConcernProfile";
import NDPProject from "./components/pages/projects/NDPProject";
import MCProject from "./components/pages/projects/MCProject";
import FPProject from "./components/pages/projects/FPProject";

function App() {
  return (
    <>
      <div>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/donation" element={<Donation />} />

          {/* About */}
          <Route path="/about/message-from-ed" element={<MessageFromEd />} />
          <Route
            path="/about/mission-and-vision"
            element={<MissionAndVision />}
          />
          <Route
            path="/about/development-concern-background"
            element={<DevelopmentConcernBackground />}
          />
          <Route path="/about/organogram" element={<Organogram />} />
          <Route
            path="/about/development-concern-profile"
            element={<DevelopmentConcernProfile />}
          />
          <Route path="/about/general-council" element={<GeneralCouncil />} />
          <Route
            path="/about/executive-council"
            element={<ExecutiveCouncil />}
          />
          <Route path="/about/moto-and-values" element={<MotoAndValues />} />
          <Route path="/about/advisory-council" element={<AdvisoryCouncil />} />
          <Route path="/about/senior-management-team" element={<SMT />} />
          <Route path="/about/constitution" element={<Constitution />} />
          <Route path="/about/audit-system" element={<AuditSystem />} />
          <Route path="/about/core-policy" element={<Policy />} />

          {/* News */}
          <Route path="/all-blogs" element={<AllBlogs />} />
          <Route path="/happy-new-year" element={<HappyNewYear />} />

          {/* Job Circular */}
          <Route
            path="/job-circular/earn-project"
            element={<JobCircularDYD />}
          />

          {/* Affiliation */}
          <Route path="/affiliation/ngoab" element={<NgoAb />} />
          <Route
            path="/affiliation/social-welfare"
            element={<SocialWelfare />}
          />
          <Route path="/affiliation/join-stock" element={<JoinStock />} />
          <Route path="/affiliation/tin-bin" element={<TinAndBin />} />
          <Route path="/affiliation/trade-license" element={<TradeLicense />} />
          <Route path="/affiliation/sam-and-duns" element={<SamAndDuns />} />
          <Route
            path="/affiliation/adb-cms-number"
            element={<AdbCmsNumber />}
          />

          {/* Focus Areas */}
          <Route path="/focusArea/focus-area" element={<FocusArea />} />
          <Route path="/focusArea/strategic-plan" element={<StrategicPlan />} />
          <Route path="/focusArea/thematic-issue" element={<ThematicIssue />} />

          {/* Projects */}
          <Route
            path="/projects/complete-project"
            element={<CompleteProject />}
          />
          <Route path="/projects/NDP-project" element={<NDPProject />} />
          <Route path="/projects/MC-project" element={<MCProject />} />
          <Route path="/projects/FP-project" element={<FPProject />} />

          {/* Donor */}
          <Route path="/donors/past-donors" element={<PastDonors />} />
          <Route path="/donors/current-donor" element={<CurrentDonor />} />

          {/* Resources */}
          <Route path="/resources/photo-gallery" element={<PhotoGallery />} />
          <Route path="/resources/annual-report" element={<AnnualReport />} />
          <Route path="/resources/audit-report" element={<AuditReport />} />
          <Route
            path="/resources/project-completion-report"
            element={<ProjectCompletionReport />}
          />

          {/* Notice Board */}
          <Route path="/noticeBoard/office-notice" element={<OfficeNotice />} />
          <Route path="/noticeBoard/tender-notice" element={<TenderNotice />} />
          <Route path="/noticeBoard/job-circular" element={<JobCircular />} />

          {/* Helpdesk */}
          <Route
            path="/helpdesk/ashroy-angon-citizen-charter"
            element={<AasCitizenCharter />}
          />
          <Route path="/helpdesk/emergency-call" element={<EmergencyCall />} />
          <Route path="/helpdesk/complain" element={<Complain />} />

          {/* Others  */}
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<Notfound />} />
        </Routes>
      </div>
    </>
  );
}

export default App;
